<script lang="ts">
        import type { ProductConfig } from '$lib/brand/types';

        interface Props {
                product: ProductConfig;
                className?: string;
        }

        let { product, className = '' }: Props = $props();

        const title = product.whatYouGet?.title ?? "What You'll Get";
        const items = product.whatYouGet?.items ?? [
                'Proven frameworks and strategies distilled into one resource',
                'Step-by-step guidance you can apply immediately',
                'Real-world examples to make concepts clear and actionable',
                'Lifetime access to your purchase, including future updates',
                "Customer-first support, so you're never stuck on your own"
        ];
</script>

<div class="product-details {className}">
        <h2>{title}</h2>
        <ul class="features-list">
                {#each items as item}
                        <li>{item}</li>
                {/each}
        </ul>
</div>

<style>
        .product-details {
                margin-bottom: 3rem;
        }

        .product-details h2 {
                font-size: 1.75rem;
                color: var(--brand-primary);
                margin-bottom: 1.5rem;
        }

        .features-list {
                list-style: none;
                padding: 0;
                margin: 0;
        }

        .features-list li {
                padding: 0.75rem 0;
                color: #374151;
                position: relative;
                padding-left: 2rem;
                font-size: 1.1rem;
        }

        .features-list li::before {
                content: "✓";
                color: var(--brand-primary);
                font-weight: bold;
                position: absolute;
                left: 0;
                font-size: 1.2rem;
        }
</style>
